// extracted by css-extract-rspack-plugin
export default {"container":"LinkItem-module__container__q2ZJh7V","leadingIcon":"LinkItem-module__leadingIcon__ncr6cB8","linkIndicator":"LinkItem-module__linkIndicator__m1PTtkD"};